var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 22,
    viewBox: "0 0 120 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 22,
    fill: "#FFF",
    rx: 0.592
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h120v22H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    x: 5.5,
    y: 6.5,
    stroke: "#212121",
    strokeOpacity: 0.204,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    fillOpacity: 0.201,
    d: "M20 8h93v6H20z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputToggle);
export default __webpack_public_path__ + "static/media/inputToggle.06784955d683e7c70b0619bbebb01489.svg";
export { ForwardRef as ReactComponent };